/* eslint-disable import/prefer-default-export */
/* eslint-disable no-undef */

// https://medium.com/once-upon-a-site/tracking-vuejs-spa-user-behaviour-with-google-analytics-37660e7a5790
const gtagBuilder = (action, label, interactive, value) => ({
  build: (category) => {
    const event = {
      event_category: category,
      event_label: label,
      non_interaction: !interactive,
    };
    if (value) {
      event.value = value;
    }
    gtag('event', action, event);
  },
});

function emitNavigationEvent(action, label, value) {
  return gtagBuilder(action, label, true, value).build('navigation');
}

function emitEngagementEvent(action, label, value) {
  return gtagBuilder(action, label, true, value).build('engagement');
}

function emitInteractionEvent(action, label, value) {
  return gtagBuilder(action, label, true, value).build('interaction');
}

function emitExperienceEvent(action, label, value) {
  return gtagBuilder(action, label, false, value).build('experience');
}

function emitClickLinkEvent(label, value) {
  return emitNavigationEvent('click_link', label, value);
}

function emitClickCtaEvent(label, value) {
  return emitNavigationEvent('click_cta', label, value);
}

export const gaEventEmitter = {
  emitNavigationEvent,
  emitEngagementEvent,
  emitInteractionEvent,
  emitExperienceEvent,
  emitClickLinkEvent,
  emitClickCtaEvent,
};
